import { useEffect, useRef, useState } from "react";

export function useInterval(
  callback: () => void,
  delay: number,
  _runInterval: boolean = true,
): [React.Dispatch<React.SetStateAction<boolean>>, boolean] {
  const savedCallback = useRef<() => void>();
  const [runInterval, setRunInterval] = useState(_runInterval);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delay !== null && runInterval) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, runInterval]);

  return [setRunInterval, runInterval];
}
